import { template as template_1392ca7ff71e4c18bd51a6f65ec29b49 } from "@ember/template-compiler";
import { formatMoney } from 'client-portal/helpers/format-money';
import Component from '@glimmer/component';
import styles from './product-details.module.scss';
export default class SiteDocumentsGoodFaithEstimateProductDetails extends Component {
    get formattedPrice() {
        return formatMoney([
            this.args.model.price
        ], {
            precision: 2
        });
    }
    get formattedTotal() {
        return formatMoney([
            this.args.model.total
        ], {
            precision: 2
        });
    }
    static{
        template_1392ca7ff71e4c18bd51a6f65ec29b49(`
    <div class={{styles.component}}>
      <div class="service-details-grid product-details-grid-row">
        <div class="product-details-container">
          <span>{{@model.productDetails}}</span>
        </div>

        <div>
          <span class="empty-cell"></span>
        </div>

        <div>
          <span class="empty-cell"></span>
        </div>

        <div class="quantity-container">
          <span>{{@model.quantity}}</span>
        </div>

        <div class="right-align fee-container">
          <span>{{this.formattedPrice}}</span>
        </div>

        <div class="right-align total-container">
          <span>{{this.formattedTotal}}</span>
        </div>
      </div>
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
